import React from 'react';
import { BaseQuestionPreviewComponent } from '../../../bases';
import { useQuestionContext } from '../../../core';
import { SpeakingRecorderPreviewComponent } from './components';
import { SpeakingSettingsBadgesComponent } from '../common';
import { useSpeakingQuestionPreview } from './hooks/use-speaking-question-preview.hook';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SpeakingPreviewComponent = function SpeakingPreviewComponent(_ref) {
  var states = _ref.states,
      actions = _ref.actions;

  var _useQuestionContext = useQuestionContext(),
      question = _useQuestionContext.question;

  var speakingQuestion = question;
  var settings = states.speakingSettings || speakingQuestion.speakingSettings;
  var label = states.speakingLabel;
  var previewRecorder = useSpeakingQuestionPreview({
    settings: settings,
    label: label,
    actions: actions,
    isDisabled: states.readonly
  });
  return /*#__PURE__*/_jsxs(BaseQuestionPreviewComponent, {
    states: states,
    actions: actions,
    children: [/*#__PURE__*/_jsx(SpeakingSettingsBadgesComponent, {
      settings: settings,
      label: label,
      currentAttempts: previewRecorder.currentAttempts,
      isAnswerMode: false,
      attemptsBeforeMinimum: true
    }), /*#__PURE__*/_jsx(SpeakingRecorderPreviewComponent, {
      label: label,
      previewRecorder: previewRecorder,
      isDisabled: states.readonly
    })]
  });
};